/**
 * Add to Home screen
 * https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps/Add_to_home_screen
 */


// # Add to Home screen Module
define('modules/A2HS/A2HS',[
    'jquery',
    'global/all',
], function ($, Roc) {
    'use strict';


    var deferredPrompt;
    var modalA2HS = document.querySelector('#modalA2HS');
    var modalA2HSFooter = document.querySelector('#modalA2HSFooter');
    var btnA2HSWrapper = document.querySelector('#btnA2HSWrapper');
    var btnA2HS = document.querySelector('#btnA2HS');
    var InfoA2HS = document.querySelector('#InfoA2HS');
    
        if (btnA2HSWrapper) {
            btnA2HSWrapper.style.display = 'none';
        }
        if (InfoA2HS) {
            InfoA2HS.style.display = 'none';
        }


    function load() {
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function() {
              navigator.serviceWorker.register('/serviceWorker.js').then(function(registration) {
                // Registration was successful
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
              }, function(err) {
                // registration failed :(
                console.log('ServiceWorker registration failed: ', err);
              });
            });
        }
    };

    function isApple() {
        return ['iPhone', 'iPad', 'iPod'].includes(navigator.platform);
    }

    function beforePrompt() {
        window.addEventListener('beforeinstallprompt', function (e) {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            deferredPrompt = e;
            btnA2HSWrapper.style.display = 'block';
            Roc.UI.Modal.open(modalA2HS);
    
            btnA2HS.addEventListener('click', function (e) {
                // hide our user interface that shows our A2HS button
                Roc.UI.Modal.close(modalA2HS);
    
                // Show the prompt
                deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                deferredPrompt.userChoice.then(function (choiceResult) {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the A2HS prompt');
                    } else {
                        console.log('User dismissed the A2HS prompt');
                    }
                    deferredPrompt = null;
                });
            });
        });
    }

    function infoAlert(){
        if(isApple() && !(window.navigator.standalone)){
            modalA2HSFooter.classList.add("info");
            btnA2HSWrapper.style.display = 'none';
            InfoA2HS.style.display = 'block';
            Roc.UI.Modal.open(modalA2HS);
        }else{
            beforePrompt();
        }
    }
    

    function init() {
        load();
        infoAlert();
    };

    var A2HS = {
        init: init
    };

    return A2HS;
});

